import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this._renderWidget();
  }

  disconnect() {
    this._alreadyRendered = false;
  }

  _renderWidget() {
    if (this._alreadyRendered) {
      return;
    }

    if (!window.turnstile) {
      // Turnstile not loaded yet, retry after a short delay
      setTimeout(() => this._renderWidget(), 100);
      return;
    }

    const target = this.element.querySelector(".cf-turnstile") ?? this.element;
    window.turnstile.render(target);
    this._alreadyRendered = true;
  }
}